
export const AllCompanySizes = [
    { value: 0, label: 'Microempresa e Empresa de Pequeno Porte (EPP)' },
    { value: 1, label: 'Pequena Empresa' },
    { value: 2, label: 'Média Empresa I' },
    { value: 3, label: 'Média Empresa II' },
    { value: 4, label: 'Grande Empresa' }
]